module.exports = __webpack_public_path__ + "static/media/Duan5.30f95bf1.png";